<template lang="pug">
    v-dialog(v-model='dialog', max-width='700px' scrollable v-if="isSuperAdmin")
        template(v-slot:activator='{ on }')
            v-btn(v-if="theme" depressed small v-on='on' @click="importTheme(theme)" ) 
              v-icon(left small) edit
              span {{$t("general.edit")}}
            v-btn(v-else color="accent" icon v-on='on') 
              v-icon add_circle
        v-card.rounded-lg.elevation-25(color="grey lighten-4")
          v-toolbar.mx-0(flat)
            v-toolbar-title.title Update / Create Theme
            v-spacer 
            v-btn( v-if="theme" link color="primary" text target="_blank" v-bind:href="''+bucket+'?prefix=protected/'+tenantId+'/themes/'+theme.id+'/&showversions=false'") bucket
          
          v-divider
          v-card-text.mt-4(v-if="!themeId")
              v-row.align-center(dense)
                v-col(cols="12")
                  v-text-field.rounded-lg.mt-2(v-model="themeForm.title" rounded filled label="Name of theme")
            
                v-col(cols="12" md="4")
                  v-card(flat)
                    v-subheader {{$t("settings.primaryColor")}}
                    v-color-picker.no-alpha(v-model="primaryColor" mode="hexa" swatches-max-height="200")
                v-col(cols="12" md="4")
                  v-card(flat)
                    v-subheader {{$t("settings.accentColor")}}
                    v-color-picker(v-model="accentColor" mode="hexa" swatches-max-height="200")
                v-col(cols="12" md="4")
                  v-card(flat)
                    v-subheader {{$t("settings.textColor")}}
                    v-color-picker(v-model="textColor" mode="hexa" swatches-max-height="200")
                v-col(cols="6")
                  v-card(flat)
                    v-subheader Add Overlay
                    v-card-text.pt-0
                      v-switch.mt-0(v-model="themeForm.addOverlay"  hide-details dense)
                v-col(cols="6")
                  v-card(flat)
                    v-subheader Exclude Intro
                    v-card-text.pt-0
                      v-switch.mt-0(v-model="themeForm.excludeIntro"  hide-details dense)
                v-col(cols="12")
                  v-card(flat)
                    v-subheader Thumbnail second
                    v-card-text
                      v-slider(v-model="themeForm.thumbnailAt" dense thumb-label="always" type="number" max="20" min="0" rounded filled)
                v-col(cols="12")
                  v-card(flat)
                    .d-flex.flex-row.justify-space-between.align-center
                      v-subheader Set music & volume of background music
                      v-switch.mt-0.mr-2(v-model="themeForm.addAudio" hide-details dense)
                    v-card-text
                      v-slider(v-if="themeForm.addAudio" v-model="themeForm.volumeDuringClips" thumb-label="always" :min="0" :max="1" :step="0.01"  prepend-icon="mdi-volume-high")    

                  
                v-col(cols="12" md="6")
                  v-card(flat)
                    v-subheader Clip overlap fade out intro music
                    v-card-text
                      v-slider( v-model="themeForm.fadeInClipOverlay" thumb-label="always" :min="0" :max="10" :step="0.01")
                v-col(cols="12" md="6")
                  v-card(flat)
                    v-subheader Clip overlap fade out outro music
                    v-card-text
                      v-slider( v-model="themeForm.fadeOutClipOverlay" thumb-label="always" :min="0" :max="10" :step="0.01" )
                v-col(cols="12")
                  v-card(flat)
                    v-subheader Logos
                    v-card-text
                      v-row.align-center(dense)
                        v-col(cols="12" md="6")
                          v-card.rounded-lg(dark flat)
                            v-card-text.px-8
                              v-img(:src="theme.logoLightUrl" )
                            v-card-actions
                              v-text-field.rounded-lg.mt-2(v-model="themeForm.logoLight" dense hide-details rounded filled label="File name (light)")
                        v-col(cols="12" md="6")
                          v-card.rounded-lg(color="grey lighten-4" flat)
                            v-card-text.px-8
                              v-img(:src="theme.logoDarkUrl" )
                            v-card-actions
                              v-text-field.rounded-lg.mt-2(v-model="themeForm.logoDark" dense hide-details rounded filled label="File name (dark)")
          v-card-text.py-12(v-else)
              | Create folder 
              code themes
              |  and a new folder with name
              code.mx-2 {{themeId}}
              | inside 
              v-btn(link small text target="_blank" v-bind:href="''+bucket+'/object/create_folder?region=eu-central-1&prefix=protected/'+tenantId+'/'") here
              | and enable encryption.
              | Now clone 
              v-btn(link small text target="_blank" 
                  v-bind:href="''+bucket+'?prefix=protected/blueprint/themes/default/&showversions=false'") theses
              | files into the new folder.
          v-divider
          v-card-actions(v-if="!themeId")
                v-spacer
                v-btn(text, color="grey" @click='closeDialog') {{$t("general.cancel")}}
                v-btn(color='accent', depressed, @click="updateBrandingFunction")  {{$t("general.save")}}
          v-card-actions(v-else)
              v-btn(depressed, color='accent', @click='closeDialog') {{$t("general.close")}}
</template>
<script>
import awsmobile from "@/aws-exports.js";
import { mapState } from "vuex";

export default {
  props: ["theme", "tenantId"],
  data() {
    return {
      dialog: false,
      primaryColor: "#104764",
      accentColor: "#F42B4F",
      textColor: "#fff",
      themeForm: {
        title: "",
        addAudio: false,
        addOverlay: false,
        excludeIntro: false,
        thumbnailAt: 5,
        volumeDuringClips: 0.3,
        fadeInClipOverlay: 5,
        fadeOutClipOverlay: 3,
        logoLight: "",
        logoDark: "",
      },
      themeId: "",
      bucket:
        "https://s3.console.aws.amazon.com/s3/buckets/" +
        awsmobile.aws_user_files_s3_bucket,
    };
  },
  computed: {
    ...mapState({
      isSuperAdmin: (state) => state.auth.isSuperAdmin,
    }),
  },
  watch: {
    primaryColor(value) {
      if (value.toString().match(/#[a-zA-Z0-9]{8}/)) {
        this.primaryColor = value.substr(0, 7);
      }
    },
    accentColor(value) {
      if (value.toString().match(/#[a-zA-Z0-9]{8}/)) {
        this.accentColor = value.substr(0, 7);
      }
    },
    textColor(value) {
      if (value.toString().match(/#[a-zA-Z0-9]{8}/)) {
        this.textColor = value.substr(0, 7);
      }
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;

      this.primaryColor = "#104764";
      this.accentColor = "#F42B4F";
      this.textColor = "#fff";
      this.themeForm = {
        title: "",
        addAudio: false,
        addOverlay: false,
        thumbnailAt: 5,
        logoLight: "",
        logoDark: "",
      };
      this.themeId = "";
    },

    importTheme(theme) {
      if (theme) {
        this.themeForm = JSON.parse(JSON.stringify(theme));
        this.primaryColor = theme.primaryColor;
        this.accentColor = theme.accentColor;
        this.textColor = theme.textColor;
      }
    },
    async updateBrandingFunction() {
      const payload = {
        ...this.themeForm,
        primaryColor: this.primaryColor,
        accentColor: this.accentColor,
        textColor: this.textColor,
        tenantId: this.tenantId,
      };
      if (this.theme) {
        const response = await this.$store.dispatch("superAdmin/UPDATE_THEME", {
          themeId: this.theme.id,
          ...payload,
        });
        if (response) this.dialog = false;
      } else {
        const response = await this.$store.dispatch(
          "superAdmin/CREATE_THEME",
          payload
        );
        if (response) {
          this.themeId = response.data.createTheme.id;
        }
      }

      this.$store.dispatch("create/FETCH_THEMES", this.tenantId);
    },
  },
};
</script>
<style lang="scss" scoped>
.no-alpha {
  .v-color-picker__controls {
    .v-color-picker__preview {
      .v-color-picker__sliders {
        .v-color-picker__alpha {
          display: none;
        }
      }
    }
    .v-color-picker__edit {
      .v-color-picker__input:last-child {
        display: none;
      }
    }
  }
}
</style>
